module.exports = __webpack_public_path__ + "static/media/promo-overlay-registry.9c8b4f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registry/promo-overlay-registry.png
// module id = 1776
// module chunks = 50